import axios from "axios";
import { Message } from "element-ui"; // 按需引入 UI 框架提示组件（可选）
import router from "@/router"; // 引入 Vue Router 实例

// 创建 Axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础请求地址, // 从环境变量读取接口地址
  timeout: 20000, // 超时时间
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求前执行的逻辑（如添加 Token）
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做统一处理（如根据业务码判断成功/失败）
    const res = response.data;
    // 如果后端没有返回 code 字段，默认认为请求成功
    if (res.code === undefined) {
      return res; // 直接返回数据
    }

    // 假设业务码 1 表示成功（根据实际接口调整）
    if (res.code != 1 && res.code != 200) {
      Message.error(res.message || res.msg || "请求失败");
      return Promise.reject(new Error(res.message || res.msg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);
    // 对 HTTP 错误状态码处理
    let message = "";
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          message = "登录已过期，请重新登录";
          // 清除本地存储的用户信息
          localStorage.removeItem("token");
          // 跳转到登录页
          router.push("/login");
          break;
        case 403:
          message = "拒绝访问";
          break;
        case 404:
          message = "请求资源不存在";
          break;
        default:
          message = `${error.response.data.message}`;
      }
    } else {
      message = "连接服务器失败";
    }
    Message.error(message);
    return Promise.reject(error);
  }
);

export default service;
